/* eslint-disable */
import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    iniciadas: null,
    iniciadasPreventivas: null,
    osEmPause: '',
    osPendente: '',
    osLiberacao: '',
    totalOsEmPause: null,
    totalOsPendente: null,
    internas: null,
    externas: null,
    preventivas: null,
    encerradas: [],
    pagination: {
      currentPage: 1,
      perPage: 10
    },
    totalEncerradas: 0,
    totalInternas: 0,
    totalArmazem: 0,
    totalArmazemExterna: 0,
    totalArmazemPreventiva: 0,
    totalArmazemPreditiva: 0,
    totalExternas: 0,
    totalPreventivas: 0,    
    totalPreditiva: 0,    
    totalReabertas: 0,
    gettersCountItensAtendidos: false,
    filters: {
      executada: 0
    },
    arrayPause: [],
    arrayPendente: [],
    arrayLiberacao: [],
  },

  getters: {
    iniciadas: (state) => {
      return state.iniciadas
    },
    iniciadasPreventivas: (state) => {
      return state.iniciadasPreventivas
    },
    osEmPause: (state) => {
      return state.osEmPause
    },
    osPendente: (state) => {
      return state.osPendente
    },
    osLiberacao: (state) => {
      return state.osLiberacao
    },
    filters: (state) => state.filters,
    encerradas: (state) => (page) => state.encerradas[page],
    totalIniciadas: (state) => {
      if (!state.iniciadas) return 0

      var totalIniciadas = 0
      state.iniciadas.forEach(element => {
        totalIniciadas += 1
      })

      return totalIniciadas
    },

    totalIniciadasPreventivas: (state) => {
      if(!state.iniciadasPreventivas) return 0

      var totalIniciadasPreventivas = []
      state.iniciadasPreventivas.forEach(element => {
        totalIniciadasPreventivas.push(element)
      })

      return totalIniciadasPreventivas.length
    },

    totalOsEmPause: (state) => state.totalOsEmPause,  
    
    totalOsPendente: (state) => state.totalOsPendente,  
    
    totalInternas: (state) => state.totalInternas,

    totalArmazem: (state) => state.totalArmazem,
    
    totalArmazemExterna: (state) => state.totalArmazemExterna,
    
    totalArmazemPreventiva: (state) => state.totalArmazemPreventiva,

    totalArmazemPreditiva: (state) => state.totalArmazemPreditiva,
    
    totalExternas: (state) => state.totalExternas,

    totalPreventivas: (state) => state.totalPreventivas,

    totalPreditiva: (state) => state.totalPreditiva,

    totalReabertas: (state) => state.totalReabertas,

    gettersCountItensAtendidos: (state) => state.gettersCountItensAtendidos,

    data: (state) => {
      return state.current.data
    },
    pagination: (state) => state.pagination,
    totalEncerradas: (state) => state.totalEncerradas
  },

  actions: {
    async countItensAtendidos( { state, commit }, { nrSequencial } ){
      try {
        const response = await api.get(`os/countItensAtendidos/${nrSequencial}`)

        commit('setCountItensAtendidos', response.data)
        return response
      } catch(error){
        commit('setCountItensAtendidos', [])
        throw Error(error)
      }

    },
    async cancelarOs( {state, commit}, { data } ){
      try{
        const response = await api.post(`os/cancelarOs`, { ...data })
        return response
      } catch (error){
        throw Error(error)
      }
    },
    async getProblemas( { state, commit }, { params } ){
      try {
        const response = await api.get(`os/novaOs/getProblema/${params.nr_problema}`, { params: params })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    
    async novaOs ({ state, commit }, { data }){
      try {
        const response = await api.post('os/itens/execucoes/novaOs', { ...data })

        return response
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },

    async finalizaItem({ commit }, { codOs }){
      try {
        const response = await api.get(`os/itens/execucoes/finalizaItem/${codOs}`)

        return response
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },

    async getItensOs ({ commit }){
      try {
        const response = await api.get('os/itens/execucoes/getItensOs')

        return response
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },

    async findPause ({ commit }, { nr_sequencial }){
      try {
        const response = await api.get(`os/itens/execucoes/findPause/${nr_sequencial}`)

        return response.data
      } catch ( error ){
        console.log(error)
        throw new Error(error)
      }
    },

    async create ({ state, commit }, { data }) {
      try {
        const filial = JSON.parse(localStorage.filial)

        data.filialExt = filial.nr_sequencial
        
        const response = await api.post('os/itens/execucoes/iniciar', { ...data })

        return response
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },

    async gerarOsTransicao({ commit }, { data }){
      try{
        const response = await api.post('os/itens/execucoes/gerarOsTransicao', { ...data })

        return response
      } catch (error){
        throw new Error(error)
      }
    },

    async validateOsIniciadaPreventiva({ commit }, { idMecanico }){
      try {
        const response = await api.get(`os/itens/execucoes/validate-iniciadas-preventiva/${idMecanico}`)

        commit('setIniciadas', response.data.items)
        return response
      } catch (error) {
        commit('setIniciadas', [])
        throw new Error(error)
      }
    },

    async iniciaPreventiva({ state, commit }, { data }){
      try {
        const response = api.post('os/itens/execucoes/iniciaPreventiva', { ...data })

        return response
      } catch (error){
        throw new Error(error)
      }
    },

    async registrarServicos({ state, commit }, { data }){
      try {
        const response = api.post('os/itens/execucoes/registrarServicos', { ...data })

        return response
      } catch (error){
        throw new Error(error)
      }

    },

    async update ({ state, commit }, { data }) {
      const filial = JSON.parse(localStorage.filial)

      data.filialExt = filial.nr_sequencial
      try {
        const response = await api.put('os/itens/execucoes/encerrar', { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async initPause ({ state, commit }, { data }) {
      try {
        const response = await api.put('os/itens/execucoes/initPause', { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async fetchIniciadasFromApi ({ commit }) {
      const filial = JSON.parse(localStorage.filial)

      const data = {
        nr_seq_filial: filial.infColab.newFilial
      }

      if(filial.infColab.newFilial === undefined){
        data.nr_seq_filial = filial.nr_sequencial
      } 

      try {
        const response = await api.post(`os/itens/execucoes/iniciadas-by-clifor`, { ...data })

        commit('setIniciadas', response.data.items)
        commit('setIniciadasPreventivas', response.data.preventivas)
        return response
      } catch (error) {
        commit('setIniciadas', [])
        commit('setIniciadasPreventivas', [])
        throw new Error(error)
      }
    },

    async validateFromOsIniciadas ({ commit }, { data }) {
      try {
        const response = await api.post(`os/itens/execucoes/validate-iniciadas-by-clifor`, { ...data })

        commit('setIniciadas', response.data.items)
        return response
      } catch (error) {
        commit('setIniciadas', [])
        throw new Error(error)
      }
    },
    async enviaObservacao ({ commit }, { data }) {
      try {
        const response = await api.post(`os/itens/execucoes/envia-observacao`, { ...data })

        commit('setIniciadas', response.data.items)
        return response
      } catch (error) {
        commit('setIniciadas', [])
        throw new Error(error)
      }
    },

    async fetchOsEmPauseFromApi ({ commit }, { nr_tipo }) {
      try {
        const params = {
          nr_tipo: nr_tipo,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os/itens/execucoes/os-em-pause', { params: params })

        if(nr_tipo == 'O' ){
          commit('setArrayPause', 0)
        }
        commit('setOsEmPause', response.data.data)
        return response
      } catch (error) {
        commit('setOsEmPause', [])
        throw new Error(error)
      }
    },
    async fetchOsAprovacao ({ commit }, { data }) {
      try {
        const params = {
          nr_tipo: data.nr_tipo,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os/itens/execucoes/os-em-aprovacao', { params: params })
        
        commit('setOsPendente', response.data.data)
        return response
      } catch (error) {
        commit('setOsPendente', [])
        throw new Error(error)
      }
    },
    async fetchOsLiberacao ({ commit }, { data }) {
      try {
        const params = {
          nr_tipo: data.nr_tipo,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os/itens/execucoes/os-em-aprovacao', { params: params })
        
        commit('setOsLiberacao', response.data.data)
        return response
      } catch (error) {
        commit('setOsLiberacao', [])
        throw new Error(error)
      }
    },

    async fetchInternasFromApi ({ commit }) {
      try {
        const params = {
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os/itens/execucoes/internas-by-clifor', { params: params })
        
        commit('setInternas', response.data.total)
        return response
      } catch (error) {
        commit('setInternas', [])
        throw new Error(error)
      }
    },

    async fetchArmazemFromApi ({ commit }) {
      try {
        const params = {
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }
        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/itens/execucoes/internas-by-clifor-armazem', { params: params })
        
        commit('setArmazem', response.data.total)
        
        return response
      } catch (error) {
        commit('setArmazem', [])
        throw new Error(error)
      }
    },

    async fetchArmazemExternaFromApi ({ commit }) {
      try {
        const params = {
          status: 'A',
          origem: 'E',
          liberado: false,
          ordernation: 'ASC'
        }

        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/itens/execucoes/internas-by-clifor-armazem', { params: params })
        
        commit('setArmazemExterna', response.data.total)
        return response
      } catch (error) {
        commit('setArmazemExterna', [])
        throw new Error(error)
      }
    },

    async fetchReabertasFromApi ({ commit }) {
      try {
        const params = {
          status: 'R',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC',
        }

        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/itens/execucoes/internas-by-clifor', { params: params })

        commit('setReabertas', response.data.total)
        return response
      } catch (error) {
        commit('setReabertas', [])
        throw new Error(error)
      }
    },

    async fetchExternasFromApi ({ commit, state }) {
      try {
        const filial = JSON.parse(localStorage.filial)
        state.filters.tipo = ''
        const params = {
          ...state.filters,
          status: 'A',
          origem: 'E',
          liberado: false,
          ordernation: 'ASC'
        }
        
        if(filial.fornecExt == 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/itens/execucoes/internas-by-clifor', { params: params })
        
        commit('setExternas', response.data.total)
        return response
      } catch (error) {
        commit('setExternas', [])
        throw new Error(error)
      }
    },

    async fetchPreventivasFromApi ({ commit, state }) {
      try {  
        const filters = {
          placa: '',
          tipo: 'V',
          de: '',
          ate: '',
          codigo: ''
        }

        const params = {
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }
        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }
        const response = await api.get('os/itens/execucoes/internas-by-clifor', { params: params })
        
        commit('setPreventivas', response.data.total)
        return response
      } catch (error) {
        commit('setPreventivas', [])
        throw new Error(error)
      }
    },

    async fetchPreditivasFromApi ({ commit, state }) {
      try {  
        const filters = {
          placa: '',
          tipo: '13',
          de: '',
          ate: '',
          codigo: ''
        }

        const params = {
          ...filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }
        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }
        const response = await api.get('os/itens/execucoes/internas-by-clifor', { params: params })
        
        commit('setPreditivas', response.data.total)
        return response
      } catch (error) {
        commit('setPreditivas', [])
        throw new Error(error)
      }
    },
    async enviaAguardandoLiberacao({ commit, state }, { data }) {
      try {
        const response = await api.post('os/itens/execucoes/enviaAguardandoLiberacao', { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async finalizarLiberacao({ commit, state }, { data }) {
      try {
        const response = await api.post('os/itens/execucoes/finalizarLiberacao', { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async fetchPreditivasFromApiArmazem ({ commit, state }) {
      try {  
        const filters = {
          placa: '',
          tipo: '13',
          de: '',
          ate: '',
          codigo: ''
        }

        const params = {
          ...filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC',
          armazem: 'S'
        }
        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }
        const response = await api.get('os/itens/execucoes/internas-by-clifor-armazem', { params: params })
        
        commit('setPreditivasArmazem', response.data.total)


        return response
      } catch (error) {
        commit('setPreditivasArmazem', [])
        throw new Error(error)
      }
    },
    
    async fetchArmazemPreventivasFromApi ({ commit, state }) {
      try {  
        const filters = {
          placa: '',
          tipo: 'V',
          de: '',
          ate: '',
          codigo: ''
        }

        const params = {
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }
        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }
        const response = await api.get('os/itens/execucoes/internas-by-clifor-armazem', { params: params })
        
        commit('setArmazemPreventiva', response.data.total)
        return response
      } catch (error) {
        commit('setArmazemPreventiva', [])
        throw new Error(error)
      }
    },

    async fetchEncerradasFromApi ({ commit, state }) {
      try {
        const filters = {
          per_page: state.pagination.perPage,
          page: state.pagination.currentPage
        }
        const response = await api.get('os/itens/execucoes/encerradas', { params: filters })

        commit('setEncerradas', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setEncerradas', { pageNumber: state.pagination.currentPage, data: [], total: 0 })
        throw new Error(error)
      }
    },

    async verificaOCAberta({ commit }, { nr_seq_os }) {
      try {
        const response = await api.get('os/itens/execucoes/verificaOCAberta', {
          params: { nr_seq_os }
        })
        return response
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  mutations: {
    setCountItensAtendidos(state, count){
      state.gettersCountItensAtendidos = count
    },

    setIniciadas (state, items) {
      state.iniciadas = items
    },

    setIniciadasPreventivas (state, items) {
      state.iniciadasPreventivas = items
    },

    setOsEmPause (state, items) {
      items.map(element => {
        state.arrayPause.push(element)
      })
      state.osEmPause = state.arrayPause
    },
    setOsPendente (state, items) {
      items.map(element => {
        state.arrayPendente.push(element)
      })
      state.osPendente = state.arrayPendente
    },
    setOsLiberacao (state, items) {
      state.arrayLiberacao = []
      items.map(element => {
        state.arrayLiberacao.push(element)
      })
      state.osLiberacao = state.arrayLiberacao
    },

    setArrayPause (state, value) {
      state.arrayPause.length = value 
    },

    setArrayPendente (state, value) {
      state.arrayPendente.length = value 
    },

    setInternas (state, totalInternas) {
      state.totalInternas = totalInternas
    },

    setArmazem (state, totalArmazem) {
      state.totalArmazem = totalArmazem
    },

    setArmazemExterna (state, totalArmazemExterna) {
      state.totalArmazemExterna = totalArmazemExterna
    },

    setArmazemPreventiva (state, totalArmazemPreventiva) {
      state.totalArmazemPreventiva = totalArmazemPreventiva
    },

    setPreditivasArmazem (state, totalArmazemPreditiva) {
      state.totalArmazemPreditiva = totalArmazemPreditiva
    },

    setExternas (state, totalExternas) {
      state.totalExternas = totalExternas
    },

    setPreventivas (state, totalPreventivas) {
      state.totalPreventivas = totalPreventivas
    },

    setPreditivas (state, totalPreditiva) {
      state.totalPreditiva = totalPreditiva
    },

    setReabertas (state, totalReabertas) {
      state.totalReabertas = totalReabertas
    },

    setEncerradas (state, { pageNumber, data, total }) {
      if (total) {
        state.totalEncerradas = total
      }

      state.encerradas[pageNumber] = data

      state.encerradas = [
        ...state.encerradas
      ]
    },

    setFilters (state, { filters }) {
      state.filters = {
        ...filters
      }
    },

    setCurrentPage (state, { page }) {
      const newPagination = {
        perPage: state.pagination.perPage,
        currentPage: page
      }

      state.pagination = { ...newPagination }
    }
  }
}

